import { AxiosInstance, AxiosPromise } from 'axios';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { OrderJobsSearchRequest, OrderJobsSearchResponse } from './OrderJobsService.types';

export class OrderJobsService implements BaseRequestEndpoints {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  create(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  search({ routeParams, queryParams }: OrderJobsSearchRequest) {
    return this.instance.get<OrderJobsSearchResponse>(`orders/${routeParams.orderGuid}/jobs`, {
      params: queryParams,
    });
  }

  getById(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  update(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  delete(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }
}
